import React from 'react'
import { connect } from 'react-redux';
import removerNotaFiscal from '../../actions/encomenda/removerNotaFiscal';

export class NotaFiscal extends React.Component {
  render () {
    return (
          <tr>
            <th>
              {this.props.exibeRemover ? <button type="button"
                        className="btn btn-sm btn-excluir"
                        onClick={() => this.props.removerNotaFiscal(this.props.notaFiscal)}>
              <i className="material-icons nav-icon">&#xe872;</i>
            </button> : ''}
            </th>
            <td>{this.props.notaFiscal.numeroDocumento}</td>
            <td>{this.props.notaFiscal.valor}</td>
            <td>{this.props.notaFiscal.volume}</td>
            <td>{this.props.notaFiscal.peso}</td>
          </tr>
    )
  }
}

export default connect(null, { removerNotaFiscal })(NotaFiscal)
